export default __webpack_public_path__ + "static/media/plan_topic_view.4901ea5a.png";